import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export interface SessionStorageHelper {
    get<T>(key: string): T | null;

    set<T>(key: string, value: T): void;

    remove(key: string): void;

    has(key: string): boolean;
}

export const sessionStorageHelper: SessionStorageHelper = {
    get<T>(key: string): T | null {
        try {
            const item = sessionStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        } catch (error) {
            console.error(`Error reading from session storage for key ${key}:`, error);
            return null;
        }
    },

    set<T>(key: string, value: T): void {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error(`Error writing to session storage for key ${key}:`, error);
        }
    },

    remove(key: string): void {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing from session storage for key ${key}:`, error);
        }
    },

    has(key: string): boolean {
        return sessionStorage.getItem(key) !== null;
    }
};

export function getShareContext(route: ActivatedRoute): Observable<string | undefined> {
    return sessionStorageHelper.has('shareToken')
        ? route.paramMap.pipe(
              map(params => params.get('shareId')),
              filter((shareId): shareId is string => {
                  if (!shareId) {
                      return false;
                  }
                  return true;
              })
          )
        : of(undefined);
}
